import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentActionType } from "../enums/shipment-action-type";

export class ShipmentActionUpdate {
                
    @ValidateProperty({ required: true })
    public type : ShipmentActionType;
    
    @ValidateProperty({ required: true })
    public rowVersion : string = '';

    public note : string|undefined = undefined;

}

        export class UpdateDeliveryShipmentAction extends ShipmentActionUpdate {

            public fixedFreightAmount : number|undefined = undefined;

            // Container Only
            public addOnCount : number|undefined = undefined;

            public addOnWeight : number|undefined = undefined;
            
            @ValidateProperty({ required: true })
            public orders : string[] = [];

            constructor() {
                super();
                this.type = ShipmentActionType.Delivery;
            }
            
        }

        export class UpdateShipmentBackhaulActionCommand extends ShipmentActionUpdate {

            constructor() {
                super();
                this.type = ShipmentActionType.Backhaul;
            }
            
        }
